import React, { useState } from 'react';
import { analyticsUtils } from 'utils/analytics-utils';
import { BaseButton } from 'fronton-react';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import { createElementKey } from 'utils';
import { Typography } from 'common/components';
import {
  adplatformTrainingWebinarItemImgBtn,
  adplatformTrainingWebinarItemMedia,
  adplatformTrainingWebinarItemMediaWrapper,
  adplatformTrainingWebinarItemPoint,
  adplatformTrainingWebinarItemPointIcon,
  adplatformTrainingWebinarItemPointsList,
  adplatformTrainingWebinarItemWrapper,
} from './adplatform-training-webinar-item-styles';
import { ADPLATFORM_TRAINING_ELEMENT_BLOCK } from '../../../../adplatform-training-constants';
import { AdplatformTrainingWebinarStructure } from '../../adplatform-training-webinar-section-constants';

type AdplatformTrainingWebinarItemProps = {
  webinarStructure: AdplatformTrainingWebinarStructure;
};

export const AdplatformTrainingWebinarItem: React.FC<AdplatformTrainingWebinarItemProps> = ({
  webinarStructure,
}) => {
  const { name, videoSrc, image, points } = webinarStructure;
  const [isVideoStarted, setIsVideoStarted] = useState(false);

  const handleWebinarPosterClick = () => {
    setIsVideoStarted(true);
    analyticsUtils.clickButtonEvent(
      ADPLATFORM_TRAINING_ELEMENT_BLOCK,
      name,
      'Больше знаний — больше продаж'
    );
  };

  return (
    <div className={adplatformTrainingWebinarItemWrapper}>
      <div className={adplatformTrainingWebinarItemMediaWrapper}>
        {isVideoStarted ? (
          <video
            className={adplatformTrainingWebinarItemMedia}
            width="100%"
            height="auto"
            title={name}
            controls
            autoPlay>
            <track default kind="captions" srcLang="ru" src="" />
            <source src={videoSrc} type="video/mp4" />
          </video>
        ) : (
          <BaseButton className={adplatformTrainingWebinarItemImgBtn} onClick={handleWebinarPosterClick}>
            <picture>
              <source srcSet={image.srcLd} media={lowerBoundsBreakpoints['--from-large-desktop']} />
              <source srcSet={image.srcD} media={lowerBoundsBreakpoints['--from-desktop']} />
              <source srcSet={image.srcT} media={lowerBoundsBreakpoints['--from-tablet']} />
              <img
                alt={image.alt}
                title={image.alt}
                className={adplatformTrainingWebinarItemMedia}
                src={image.srcM}
              />
            </picture>
          </BaseButton>
        )}
      </div>
      <ol className={adplatformTrainingWebinarItemPointsList}>
        {points.map((point, index) => (
          <li className={adplatformTrainingWebinarItemPoint} key={createElementKey('webinar-point', index)}>
            <point.icon
              className={adplatformTrainingWebinarItemPointIcon}
              size="xxl"
              color="text-primary"
              type="outline"
              strokeWidth={0.8}
            />
            <Typography variant="m" size="body_short">
              {point.text}
            </Typography>
          </li>
        ))}
      </ol>
    </div>
  );
};
